import { SET_ARTICLES } from '../constants/mutations';
import axios from 'axios';

const state = {
    articles: [],
};

const getters = {
    articles: (state) => state.articles,
};

const actions = {
    getArticlesAsync({ commit }) {
        return axios.get('api/articles').then((res) => commit(SET_ARTICLES, res.data));
    },
};

const mutations = {
    [SET_ARTICLES](state, payload) {
        state.articles = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
